import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

type GetNotificationsResponse = {
	ReceiveNotifications: boolean;
};

const initialState: GetNotificationsResponse = {
	ReceiveNotifications: false,
};

export const { thunk: getNotifications, slice: getNotificationsSlice } = getThunkAndSlice<
	Record<string, never>,
	GetNotificationsResponse
>({
	initialState,
	path: "/api/Account/GetNotifications",
	method: "get",
});
